import {
  ApplicationConfig,
  provideZoneChangeDetection,
  importProvidersFrom,
} from "@angular/core";
import {
  HttpClient,
  provideHttpClient,
  withInterceptorsFromDi,
  withInterceptors,
} from "@angular/common/http";
import { httpToastInterceptor } from "./core/interceptors/http-toast.interceptor";
import { routes } from "./app.routes";
import {
  provideRouter,
  withComponentInputBinding,
  withInMemoryScrolling,
} from "@angular/router";
import { provideAnimationsAsync } from "@angular/platform-browser/animations/async";
import { provideClientHydration } from "@angular/platform-browser";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";

// icons
import { provideTablerIcons, TablerIconsModule } from "angular-tabler-icons";
import * as TablerIcons from "angular-tabler-icons/icons";

// perfect scrollbar
import { NgScrollbarModule } from "ngx-scrollbar";

//Import all material modules
import { MaterialModule } from "./material.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { provideToastr } from "ngx-toastr";

export function HttpLoaderFactory(http: HttpClient): any {
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}

import { authTokenInterceptor } from "./core/interceptors/auth-token.interceptor";

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      routes,
      withInMemoryScrolling({
        scrollPositionRestoration: "enabled",
        anchorScrolling: "enabled",
      }),
      withComponentInputBinding()
    ),
    provideHttpClient(
      withInterceptors([authTokenInterceptor, httpToastInterceptor]),
      withInterceptorsFromDi()
    ),
    provideClientHydration(),
    provideAnimationsAsync(),
    provideToastr({
      timeOut: 10000,
      positionClass: "toast-bottom-right",
      preventDuplicates: true,
    }),
    provideTablerIcons(TablerIcons),
    importProvidersFrom(
      FormsModule,
      ReactiveFormsModule,
      MaterialModule,
      NgScrollbarModule,
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient],
        },
      })
    ),
  ],
};
